/**
 * Feature Flag Definitions
 *
 * This file contains all feature flags used throughout the Soteria application.
 */

export const FEATURE_FLAGS = {
  NOTIFICATIONS: 'NOTIFICATIONS',
  COMMUNITY_GROUP_OBJECTS: 'COMMUNITY_GROUP_OBJECTS',
  IMAGE_CLASSIFICATION: 'IMAGE_CLASSIFICATION',
  MODERATION: 'MODERATION',
  STANDARD_LABELS: 'STANDARD_LABELS',
  CALLBACK_AUTHENTICATION: 'CALLBACK_AUTHENTICATION',
  SECURITY_GROUPS: 'SECURITY_GROUPS',
  AUTHENTICATION_PROVIDERS: 'AUTHENTICATION_PROVIDERS',
  GUIDE: 'GUIDE',
} as const;

export type FeatureFlag = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];

/**
 * Feature Flag Display Names
 *
 * Maps feature flag keys to user-friendly display names for the UI.
 * If a feature flag is not defined here, the flag string will be used as fallback.
 */
export const FEATURE_FLAG_DISPLAY_NAMES: Record<FeatureFlag, string> = {
  [FEATURE_FLAGS.NOTIFICATIONS]: 'Notifications',
  [FEATURE_FLAGS.COMMUNITY_GROUP_OBJECTS]: 'Community Group Objects',
  [FEATURE_FLAGS.IMAGE_CLASSIFICATION]: 'Image Classification',
  [FEATURE_FLAGS.MODERATION]: 'Moderation',
  [FEATURE_FLAGS.STANDARD_LABELS]: 'Standard Labels',
  [FEATURE_FLAGS.CALLBACK_AUTHENTICATION]: 'Callback Authentication',
  [FEATURE_FLAGS.SECURITY_GROUPS]: 'Security Groups',
  [FEATURE_FLAGS.AUTHENTICATION_PROVIDERS]: 'Authentication Providers',
  [FEATURE_FLAGS.GUIDE]: 'Navigation Guide',
} as const;

/**
 * Get the display name for a feature flag
 * @param featureFlag - The feature flag to get the display name for
 * @returns The display name if defined, otherwise the feature flag string
 */
export function getFeatureFlagDisplayName(featureFlag: FeatureFlag): string {
  return FEATURE_FLAG_DISPLAY_NAMES[featureFlag] || featureFlag;
}
